import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "app-sidebar-logo px-5",
  id: "kt_app_sidebar_logo"
}
const _hoisted_2 = {
  key: 0,
  alt: "Logo",
  src: "/logo-dark.png",
  class: "h-40px app-sidebar-logo-default"
}
const _hoisted_3 = {
  key: 1,
  alt: "Logo",
  src: "/logo.png",
  class: "h-40px app-sidebar-logo-default"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/logo-dark.png",
  class: "h-40px app-sidebar-logo-minimize"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  id: "kt_app_sidebar_toggle",
  class: "app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "app-sidebar-minimize"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 rotate-180" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angles-left" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        (
          _ctx.layout === 'dark-sidebar' ||
          (_ctx.themeMode === 'dark' && _ctx.layout === 'light-sidebar')
        )
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.themeMode === 'light' && _ctx.layout === 'light-sidebar')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4
      ]),
      _: 1
    }),
    (_ctx.sidebarToggleDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}